<template>
    <transition name="cz3__fade">
        <base-button-icon
            v-show="showUndo"
            @click="undoLastChange"
            icon-name="undo"
            :button-text="$t('UNDO')"
            :hide-text="isWordyLocale"
        />
    </transition>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButtonIcon from './BaseButtonIcon.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonIcon,
        },

        computed: {
            userMadeSelection() {
                return this.customizerStore.userMadeSelection;
            },

            showUndo() {
                return this.userMadeSelection;
            },

            isWordyLocale() {
                return this.customizerStore.isWordyLocale;
            },
        },

        methods: {
            undoLastChange() {
                this.customizerStore.undoSelections();
            },
        },
    };
</script>
